<template>
  <v-container>
              <v-row dense class="input-text-size">
                <v-col cols="5">
                  <v-text-field dense
                  hide-details label="Tax Year" v-model.number="editedItem.taxYear"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>

                <v-col cols="5">
                  <v-select class="input-text-size "
                  :items="taxDistrictListForTifBase"
                  item-text="taxDistrictCodeAndName"
                  item-value="districtCode"
                  label="TIF Base Tax District"
                  dense
                  v-model="editedItem.tifTaxDistrict"
                  @input="handleLoadLavyList"
                ></v-select>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="5">
                  <v-text-field dense
                  hide-details label="Description"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  v-model="editedItem.description" ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-select class="input-text-size "
                  :items="taxDistrictListForTifDistribution"
                  item-text="taxDistrictCodeAndName"
                  item-value="districtCode"
                  label="TIF Distribution Tax District"
                  dense
                  v-model="editedItem.distributionTaxDistrict"
                ></v-select>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="5">
                  <v-text-field dense
                  hide-details label="City"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  v-model="editedItem.city" ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="5">
                  <v-text-field dense v-model.number="editedItem.baseValue"
                  @input="calculateTragetAmount"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  hide-details label="Base Value"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-text-field dense v-model.number="editedItem.levy"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  hide-details label="Levy" ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="6">
                  <v-text-field dense v-model.number="editedItem.targetAmount"
                  hide-details label="Target Amount"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-text-field dense v-model.number="editedItem.collections"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  label="Collection"
                  hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="6">
                  <v-text-field dense v-model.number="editedItem.distributions"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  hide-details label="Distribution"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-text-field dense v-model.number="editedItem.overgaeToTif"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                  label="% Of Overage to TIF"
                  hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="input-text-size">
                <v-col cols="5">
                  <v-checkbox
                    id="tifDistrictsEditItemIsPageBreak"
                    class="tif-districts-edit-item-is-page-break"
                    dense
                    hide-details
                    v-model="editedItem.pageBreakBefore"
                    label="Page Break After"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
  </v-container>
</template>

<script>
import {
  mapActions, mapState,
  mapGetters, mapMutations,
} from 'vuex';
import {
  toFiscalYear,
} from '../../../util/shared/tmc-global';
import { amountFormat, amountToNumber } from '../../../util/shared/vue-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  mixins: [GlobalToCaps],
  data() {
    return {
      totalmillsVal: null,
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items']),
    ...mapGetters(['todaysDate']),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    taxDistrictListForTifDistribution() {
      const taxDistrictBaseCrudKey = 'sharedTaxDistrict';
      const items = this.items(taxDistrictBaseCrudKey) || [];
      const updatedItem = items.filter((ft) => ft.isTifDistribution).map((i) => ({
        ...i,
        taxDistrictCodeAndName: `${i.districtCode} ${i.districtName || ''}`,
      }));
      return [...updatedItem];
    },
    taxDistrictListForTifBase() {
      const taxDistrictBaseCrudKey = 'sharedTaxDistrict';
      const items = this.items(taxDistrictBaseCrudKey) || [];
      const updatedItem = items.filter((ft) => ft.isTifBase).map((i) => ({
        ...i,
        taxDistrictCodeAndName: `${i.districtCode} ${i.districtName || ''}`,
      }));
      return [...updatedItem];
    },
    currentFiscalYear() {
      return toFiscalYear(new Date(this.todaysDate));
    },
  },
  methods: {
    ...mapActions('shared/taxLevy', [
      'loadTaxLevy',
    ]),
    ...mapActions('shared/taxUnit', [
      'loadMaxFiscalYear',
    ]),
    calculateTragetAmount() {
      const item = this.item(this.baseCrudKey);
      const targetAmt = amountFormat((item.baseValue * item.levy) / 1000);
      this.editedItem.targetAmount = amountToNumber(targetAmt);
    },
    ...mapMutations('base/crud', ['setItem']),
    async handleLoadLavyList() {
      const taxDistrictBaseCrudKey = 'sharedTaxDistrict';
      const items = this.items(taxDistrictBaseCrudKey);
      const id = items.filter((el) => el.districtCode === this.editedItem.tifTaxDistrict);
      const criteria = {
        taxDistrict: id.length ? id[0]._id : null,
        taxYear: this.editedItem.taxYear,
      };
      const maxFiscalYear = await this.loadMaxFiscalYear() || this.currentFiscalYear;

      if (maxFiscalYear) {
        criteria.fiscalYear = maxFiscalYear;
      }

      if (criteria.taxDistrict && this.editedItem.taxYear) {
        const res = await this.loadTaxLevy({
          criteria,
        });
        const totalmills = res.reduce((acc, curr) => acc + curr.mills, 0);
        this.editedItem.levy = totalmills || 0;
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  max-width: 600px;
  margin: 0 auto;
}

</style>
